<button
  class="btn"
  type="button"
  [ngClass]="classNames"
  (click)="clicked.emit()"
  [disabled]="isDisabled || isLoading"
>
  <span [ngClass]="{ 'invisible': isLoading }">
    {{ labelKey | translate }}
  </span>
  <app-spinner
    *ngIf="isLoading"
    class="button-spinner"
  ></app-spinner>
</button>
